import React from "react";
import { Trophy, Sparkles } from "lucide-react";
import { useLang } from "../lib/i18n";

const TOTAL_APPS = 909;
const RANK_CAP   = 100;

/**
 * Contest badge — celebrates the TOP 100 ranking at the Emergent France contest.
 * Emphasizes the achievement by naming the total pool of 909 French apps submitted.
 */
export default function ContestBadge() {
  const { lang } = useLang();
  const isFr = lang === "fr";

  return (
    <a
      href="https://emergent.sh"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="contest-badge"
      title={isFr
        ? `Classée dans le TOP ${RANK_CAP} sur ${TOTAL_APPS} apps françaises au concours Emergent 2026`
        : `Ranked in the TOP ${RANK_CAP} out of ${TOTAL_APPS} French apps at the Emergent 2026 contest`}
      className="group inline-flex items-stretch gap-0 rounded-2xl overflow-hidden border-2 border-[#F4A261] shadow-md hover:shadow-lg transition-shadow bg-white"
    >
      {/* Left: medal */}
      <div className="relative px-4 py-2.5 bg-gradient-to-br from-[#F4A261] via-[#E07A5F] to-[#D56D52] grid place-items-center shrink-0">
        <Trophy className="w-6 h-6 text-white drop-shadow-sm" strokeWidth={2.3} />
        <Sparkles className="absolute top-1 right-1 w-2.5 h-2.5 text-white/80 animate-pulse" />
      </div>
      {/* Right: wording */}
      <div className="flex flex-col justify-center leading-tight pl-3 pr-4 py-1.5">
        <div className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-widest font-extrabold text-[#E07A5F]">
          <span>🏆</span>
          <span>{isFr ? "Lauréat 2026" : "2026 Winner"}</span>
        </div>
        <div className="font-heading text-[15px] text-[#3D405B] mt-0.5">
          {isFr ? (
            <>
              TOP <span className="font-black">{RANK_CAP}</span> sur{" "}
              <span className="font-black text-[#E07A5F]">{TOTAL_APPS}</span> apps
            </>
          ) : (
            <>
              TOP <span className="font-black">{RANK_CAP}</span> of{" "}
              <span className="font-black text-[#E07A5F]">{TOTAL_APPS}</span> apps
            </>
          )}
        </div>
        <div className="text-[11px] text-[#8A8D91] mt-0.5">
          {isFr ? (
            <>
              Concours <span className="font-semibold text-[#3D405B]">Emergent</span> France
            </>
          ) : (
            <>
              <span className="font-semibold text-[#3D405B]">Emergent</span> France Contest
            </>
          )}
        </div>
      </div>
    </a>
  );
}
